<template>
<div  class="container-fluid">
 
<!-- Modal CONFIRM -->
<modalConfirm ref="confirmModal" />

<div class="card border-primary">

  <div class="card-header bg-primary text-white">
    <h4>
        <i class="fas fa-boxes mr-2" aria-hidden="true"></i>  
        CARICO DIRETTO (DDT/FATTURA)
    </h4>

    
  </div>
  
  <div class="card-body">

    <!-- MAIN  -->
    <div v-if="type == 'Main'">  


        <div class="d-flex align-items-center mt-2">

            <!-- Supplier Select -->
            <supplier-select
                :props="supplier"
                @update="setSupplierId"
            ></supplier-select>

        </div>

    <!-- LAST TOP DOCUMENTS  -->
    <div class="col-md-4"> 
        <label for="customRange3"><strong>ULTIMI
        <span  class="badge badge-pill badge-primary">{{ range }}</span>
         DOCUMENTI</strong> </label>
        <input type="range" class="custom-range" min="10" max="100" step="10" id="customRange" v-model="range">
    </div>
    
    <button :disabled="!supplier.Id" @click="getData()" class="btn btn-primary mt-1 mb-2">      
      <i class="fas fa-binoculars mr-2" aria-hidden="true"></i>
      LISTA DOCUMENTI [DDT/FATTURA]
    
    </button>

 <!-- Pulsante -->
            <button @click="type='supplierForm'" class="btn btn-success ml-3 mt-1 mb-2 mr-1">
                <i class="far fa-id-card mr-2"></i>
                ANAGRAFICA FORNITORI
            </button>

    </div>

     <!-- SUPPLIER LIST -->    
    <div v-else-if="type == 'supplierForm'">
        
        <button  @click="type='Main'" class="btn btn-secondary mb-2">      
            <i style="color:yellow" class="fas fa-reply mr-2" aria-hidden="true"></i>
            RITORNA A CARICO DIRETTO
        </button>

        <!-- LIST -->
        <supplier-list></supplier-list>

    </div>



    <!-- SUPPLIER DOCUMENTS --> 
    <div v-else-if="type == 'supplierDocuments'">

            <div class="card border-0">
                <div class="btn-group" role="group" aria-label="Basic example">

                
                <button  @click="init()" class="btn btn-secondary  mt-1 mb-1">      
                <i style="color:yellow" class="fas fa-reply mr-2" aria-hidden="true"></i>
                RITORNA A LISTA FORNITORI
            </button>

            <!-- BUTTON NEW DOCUMENT -->
            <button  @click="newDocument()" class="btn btn-primary mt-1 mb-1">      
                <i class="fas fa-file-alt mr-2" aria-hidden="true"></i>
                NUOVO DOCUMENTO
            </button>   
             </div>  
             </div>
             
            <!-- SUPPLIER DOCUMENT LIST -->
            <documents-list @update="openDocument" :key="refresh" v-bind:range="range"  v-bind:name="supplier.name"  v-bind:supplierId="supplier.Id"></documents-list>
            

    </div>
 
    <div v-else-if="type == 'openDocument'">
                       
            <div v-if="step==1">                           
                <document-products  @addProduct="addProduct(2)"  @supplierDocuments="type = 'supplierDocuments'" v-bind:doc="doc"  @editRow="editProduct"  ></document-products>           
            </div>            

            <div v-else-if="step==2">            
                <document-header class="text-center"  v-bind:doc="doc" ></document-header> 
                <product :key="refresh"  @back="step=1"  @update="item => setProductVariants(item, 3)"   v-bind:item="product" v-bind:doc="doc"></product>
            </div>    
            
            <div v-else-if="step==3">            
                <productVariants  @back="step=2" v-bind:doc="doc" @finish="ToDoList" v-bind:product="product"></productVariants>   
            </div> 

            <div v-else-if="step==4">            
                <productVariants :update="true"  @back="step=1" v-bind:doc="doc" @finish="step=1" v-bind:product="product"></productVariants>   
            </div> 
                        

    </div>
      
    <!-- NEW DOCUMENT --> 
    <div v-else-if="type == 'newDocument'">
        
        <div v-if="step==1">
        
            <button  @click="type='supplierDocuments'" class="btn btn-secondary btn-block mb-1 ml-2">      
                <i style="color:yellow" class="fas fa-reply mr-2" aria-hidden="true"></i>
                RITORNA A LISTA DOCUMENTI
            </button>

            <!-- DOCUMENT -->
            <document v-bind:supplier="supplier" @update="setDocument"></document> 

        </div>
                
    </div>

        <div v-else-if="type=='customLabel'">


                <button  @click="closeCustomLabel()" class="btn btn-primary btn-block mt-1 mb-1">      
                <i style="color:yellow" class="fas fa-share mr-2" aria-hidden="true"></i>
                PROCEDI
                </button>
                <customLabelUpdate @update="customlabel=false" v-bind:item="product"></customLabelUpdate>

        </div>
        <div v-else-if="type=='Z'">
        <!-- CLASSIFICATION AND PRINT LABELS -->
        

        <div v-if="classificationForm">
            <button  @click="printLabels()" class="btn btn-info btn-block mt-1 mb-1">      
                <i style="color:yellow" class="fas fa-reply mr-2" aria-hidden="true"></i>
                TERMINA E STAMPA ETICHETTE
            </button>
            <div class="card">                     
                <h5 class="card-header header">
                    CLASSIFICAZIONE     
                    <product-info v-bind:productId="product.productId"></product-info>                
                    </h5>
                <div class="card-body">                       
                    <product-market v-bind:item="product" ></product-market>
                    <supplierEAN v-if="company.Id == 57" v-bind:item="product"></supplierEAN>
                    </div>
            </div>
        </div>

        
        <div v-if="printingForm">
                


                <printZebraModal @close="initDocument()" v-bind:data='barcodesList'></printZebraModal>
                <print-epl-modal @close="initDocument()" v-bind:data='barcodesList'></print-epl-modal>  

                <div class="jumbotron jumbotron-fluid mt-15">
                    <div class="container">
                        <h4 class="display-4">STAMPA ETICHETTE</h4>
                        <p class="lead"></p>
                    </div>
                </div>


        </div>

        </div>

<!-- BODY -->      
</div>

<!-- CARD -->
</div> 






 <div v-if="false">
      <h5 class="mb-4">Dati JSON:</h5>
      <pre> {{ doc }}</pre> 
      
    </div>

</div>    
</template>

<script>

import api               from '@/api'

import supplierSelect    from '@/components/common/SupplierSelect_1.vue'
import documentsList     from '@/components/backOffice/ready/SupplierDocuments.vue'
import document          from './DocumentForm.vue'
import documentProducts  from '@/components/backOffice/ready/DocumentProducts.vue'
import documentHeader    from '@/components/backOffice/ready/DocumentHeader.vue'
import product           from '@/components/backOffice/ready/ProductForm.vue'

import tab               from '@/components/backOffice/ready/tab/ProductTab.vue'
import productStock      from '@/components/product/productStock.vue' 

import supplierList      from '@/components/supplier/SupplierList.vue'
import printZebraModal   from '@/components/common/PrintZebraModal.vue'
import printEplModal     from '@/components/common/PrintJSPMModal.vue'
import productMarket     from '@/components/backOffice/ready/tab/ProductMarketPlace.vue'
import productInfo       from '@/components/product/ProductInfo.vue'
import supplierEAN       from '@/components/backOffice/ready/tab/SupplierBarcodes.vue'
import productVariants   from './ProductVariants.vue'
import modalConfirm      from '@/components/modalDialog/ModalConfirm.vue'
import customLabelUpdate from '@/components/backOffice/ready/tab/CustomLabelUpdate.vue'


import { mapGetters }    from 'vuex';



export default {
    
    components   : {supplierSelect,
        documentsList,
        document,
        documentProducts,
        documentHeader,
        product,
        tab,
        productStock,
        supplierList,
        printZebraModal,
        printEplModal,
        productMarket,
        productInfo,
        supplierEAN,
        productVariants,modalConfirm,customLabelUpdate
        
    }, 
    data()
    {
        return{


           
            supplierEAN  : false,
            range        : 10,
            
            type         : 'Main',
            step         : 1,
            add_product  : false,            
            refresh      : 0,
            doc          : {},          
            product      : {

                productId : 0
            },   
            
            productMP  : false,

            printer_type : '',

            supplier        : 
            {
                Id            : 0,
                isActive      : true,
            
                optionBase    : false,
                required      : false,
                small         : true

            },
            saved_type            : '',
            classificationForm    : false,
            printingForm          : false,
            customLabel           : false
            
        }
    },
    computed: 
    {
        ...mapGetters(['company']), 

    },
    /*
    async beforeRouteLeave(to,from,next)
    {
        // console.log('FROM',from)
        
        /*
        if(this.type == 'openDocument' || this.type == 'newDocument' )
        {
            if(this.step == 3 || this.step == 4)
            {

                const msg = 'OPERAZIONE DI REGISTRAZIONE MOVIMENTO IN CORSO  \n SI DESIDERA USCIRE COMUNQUE  ?' 
        
                 const confirmed = await this.$refs.confirmModal.show(
                    msg,
                    { title: 'ATTENZIONE' },1
                    )

                    if (!confirmed) return
                    this.$refs.confirmModal.close()



            }
        }
        


        //console.log(to,from)
        next()

        
    },
    */
    
  mounted(){

        history.pushState(null, null, document.URL)

  },
    methods : {
        
        async closeCustomLabel()
        {
            // this.barcodesList = await this.getDataToPrint()
            this.customLabel = false
        },
        awaitPromise()
        {
           
            this.customLabel = true
            return new Promise(resolve => {
                const unwatch = this.$watch('customLabel', val => {
                if (!val) {
                    unwatch()
                    resolve()
                }
                })
            })
    },
    

        async getDataToPrint()
        {
        
        const productId   = this.product.productId    
        const movementId  = this.doc.stockMovementId
        const sp          = 'spStockMovementProductBarcodes'
        const payload     = {'companyId' : this.company.Id,sp,productId,movementId}
        
        try{
        
        const res = await api.post(payload)
          if (res.status !== 200) 
          {
            throw new Error(res.data ||  res)
          }
        
            return res.data.recordsets[0]
                  
        }catch(err)
          {
            
            console.log(err)
            return []
          }  
                                                        
               
    },




        async ToDoList(items)
        {   


            this.saved_type        = this.type  
            
            // this.barcodesList      = items[0]

            this.printer_type      = items[0][0].printer_type
            
           

            const mpClassification = items[1].length > 0
            const customLabel      = items[2].length > 0

             if(this.company.shopify && process.env.NODE_ENV == 'production')
                {
                    api.shopifyCreateProductVariants(this.company.Id,this.product.productId)
                }    

            

            if(customLabel)    
            {
                this.type = 'customLabel'

                await this.awaitPromise() 
                
            }


                
            /* CLASSIFICAZIONE MP - STAMPA ETICHETTE*/
            this.type = 'Z'
            

            if(mpClassification)
            {   
                this.classificationForm = true
            }
            else
            {
               
                this.printLabels()
            }
            
        },
        addProduct(step)
        {
          
            this.product.productId = 0 
            this.product.sku       = ''
            
            this.step              = step
            
        },

        /*
        setOption(product,opt)
        {   

            
            this.item.productId  = product.productId
            this.item.sku        = product.sku
            this.item.storeId    = product.storeId
            this.item.movementId = product.stockMovementId 



            if(opt=='tab')
            {
                this.sub_type = 'B5'
            }
            else
            {
                this.sub_type = 'B6'
            }    
        },

        */
        editProduct(item)
        {
            /*
            this.item.productId = item.productId
            this.item.movementId = item.stockMovementId
            */
            this.product.productId = item.productId
            
            this.step = 4


        },


 
        openDocument(item)
        {  
            
            this.doc = item
            this.type = 'openDocument'   
            this.step = 1               
            
        },
       
        init()
        {

            this.type    = 'Main'
            
            this.step    = 1

            //this.doc.supplierId = null

            this.product = {}
            this.product.productId = 0
            this.product.counter = 1
            

            this.refresh++

        },
        newDocument()
        {
            
            this.type = 'newDocument'
            this.step = 1

        },
        setSupplierId(Id,text)
        {
            this.supplier.name  = text
            this.supplier.Id    = Id          
        },
        getData()
        {
            this.type = 'supplierDocuments'
            this.refresh++
        },
        setDocument(doc)
        {  

            this.doc  = doc
            //this.step = 2
            this.type = 'supplierDocuments'   
            this.refresh++
            
        },
        setProductVariants(product,step)
        {   
            //console.log('PRODUCT',product)            
            this.product = product            
            this.step = step
        },

        /*
        setStock(barcodes,sizes,counter)
        {
            
            this.product.barcodes = barcodes
            this.product.counter = counter
            this.product.sizes = sizes
            this.$store.commit('AUTH_LOGOUT_BTN',true)
            this.step = 3

        },
        */

       
        setProductMP()
        {   
            this.add_product = false
            this.productMP = true
        },
        initDocument()
        {
            
            this.product.productId = 0
            this.product.sku       = ''
            this.product.counter   = 0
            this.type              = this.saved_type


            this.step              = this.type == 'newDocument' ? 3 : 2
            
            this.classificationForm    = false
            this.printingForm          = false  


            /*
            this.productMP         = false
            this.product.productId = 0
            this.product.sku       = ''
            this.product.counter   = 0
            this.type              = 'B'
            this.sub_type          = 'B2'
            this.add_product       = false
            this.step              = 1
            this.$store.commit('AUTH_LOGOUT_BTN',false)
            */
            
        },
        async printLabels()        
        {   

            this.barcodesList = await this.getDataToPrint()

            this.classificationForm = false            
            this.printingForm       = true
            if(this.printer_type == 'ZPL')

            
                {    
                
                
                this.$nextTick(() => {
                   
                   $('#printZebraModal').modal({keyboard: false,backdrop:'static','show':true});
            
                 })
                
                
                }
                else
                {    
                 this.$nextTick(() => {
                    $('#printEPLModal').modal({keyboard: false,backdrop:'static','show':true});
            
                    })
                }    



        },

        



    }
}
</script>

<style scoped>
h4 {
  font-family   : 'Roboto Condensed';
  font-size     : 18px;
}
.pointer:hover
 {
    _color            : beige;
    _background-color : darkgreen;
    
}
.add-product{
  background: darkmagenta;
  color:yellow ;
  font-weight: 400;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  cursor: pointer;
 
  box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.2);
}
.card-header_
{
  height: 45px;
}

.header
{
    height: 70px !important
}
.badge-pill
{
    font-size: large;
}
</style>
